import React, { useEffect } from "react";
import { Button, InputField } from "../ui";
import { useFormik } from "formik";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { appService } from "@/services";
import { toast } from "react-toastify";
import { RootState } from "@/config/store";
import { Schema } from "@/schema/schema";

interface SuccessProps {
    success: boolean;
    onSuccess: () => void;
    onClose: () => void;
}

const Add_Address:React.FC<SuccessProps> = ({ success, onSuccess, onClose }) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const { error, isLoading } = useSelector((state: RootState) => state.addAddress);

  const formik = useFormik({
    initialValues: {
      walletAddress: "",
      mainNet: "",
      addressName: "",
    },
    validationSchema: Schema.AddWalletAddressSchema,
    onSubmit: (values) => {
      dispatch(
        appService.AddWalletAddress(
          values.walletAddress,
          values.mainNet,
          values.addressName
        )
      ).then(() => {
        onSuccess();
      });
    },
  });

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <InputField
        variant="borderless"
        type="text"
        name="walletAddress"
        label="Wallet Address"
        placeholder="enter wallet address"
        value={formik.values.walletAddress}
        onChange={formik.handleChange}
      />
      <InputField
        variant="borderless"
        type="text"
        name="mainNet"
        label="Main Net"
        placeholder="enter main net"
        value={formik.values.mainNet}
        onChange={formik.handleChange}
      />
      <InputField
        variant="borderless"
        type="text"
        name="addressName"
        label="Address Name"
        placeholder="enter address name"
        value={formik.values.addressName}
        onChange={formik.handleChange}
      />

     <section className="wrapper_cancel">
       <Button
        variant="auth__btn_cancel"
        color="default"
        type="button"
        label="Cancel"
        onClick={onClose}
      />
         <Button
        variant="auth__btn"
        color="primary"
        type="submit"
        label="Confirm"
        loading={isLoading}
        disabled={isLoading}
      />
     </section>
    </form>
  );
};

export default Add_Address;
